import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function EncounterAge({ data }) {
    const encounterByAgeChart = useMemo(() => {
        const source = data?.encountersByAgeRange || [];

        const order = [
            "Menor de 18",
            "18-29",
            "30-39",
            "40-49",
            "40-59",
            "60+",
            "Não informado",
        ];

        const orderMap = {};
        order.forEach((label, index) => {
            orderMap[label] = index;
        });

        const sortedSource = [...source].sort((a, b) => {
            const indexA = orderMap[a.age_group];
            const indexB = orderMap[b.age_group];
            return indexA - indexB;
        });

        return {
            labels: sortedSource.map(item => item.age_group),
            values: sortedSource.map(item => Number(item.count || 0)),
        };
    }, [data]);

    useEffect(() => {
        GraphicUtils.barChart(
            "encounter-by-age",
            encounterByAgeChart.values,
            encounterByAgeChart.labels,
        );
        if (encounterByAgeChart.values.some(v => v > 0)) {
            ReportUtils.createExportableTable(
                encounterByAgeChart.labels,
                encounterByAgeChart.values,
                "Faixa etária dos indivíduos",
            );
        }
    }, [encounterByAgeChart]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Faixa etária dos indivíduos abordados</span>
                <div className="mt-3" id="encounter-by-age" />
            </div>

            <div className="chart-divisor" />
        </>
    )
}